<ion-header mode="ios">
  <ion-toolbar color="secondary">
    <ion-title class="text-grey-ultra-dark">{{ 'pages.card-mgmt.edit-pin.title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="flex flex-column min-height-100">
    <div *ngIf="isActivation">
      <div class="font-medium subtitle">{{ 'pages.card-mgmt.edit-pin.activateSubtitle' | translate }}</div>
      <div class="font-regular message" [innerHTML]="'pages.card-mgmt.edit-pin.activateMessage' | translate"></div>
    </div>
    <div *ngIf="!isActivation">
      <div class="font-medium subtitle">{{ 'pages.card-mgmt.edit-pin.subtitle' | translate }}</div>
      <div class="font-regular message" [innerHTML]="'pages.card-mgmt.edit-pin.message' | translate"></div>
    </div>
    <form [formGroup]="form" (ngSubmit)="updatePin()" class="pin-form">
      <ui-form-field [control]="form.controls.newPin" label="pages.card-mgmt.edit-pin.new">
        <ion-input type="password" [formControl]="form.controls.newPin"></ion-input>
      </ui-form-field>
      <ui-form-field [control]="form.controls.confirmNewPin" label="pages.card-mgmt.edit-pin.confirm">
        <ion-input type="password" [formControl]="form.controls.confirmNewPin"></ion-input>
      </ui-form-field>
    </form>

    <ui-bottom-actions>
      <ion-buttons mode="ios">
        <ion-button (click)="updatePin()" color="primary" expand="block" fill="solid" [disabled]="!form.valid">
          {{ 'pages.card-mgmt.edit-pin.button' | translate }}
        </ion-button>
      </ion-buttons>
    </ui-bottom-actions>
  </div>
</ion-content>
